import type { InfluencerFormData } from "./types";

export const INITIAL_INFLUENCER_STATE: InfluencerFormData = {
  id: 0,
  fullName: "",
  platform: "Instagram",
  handle: "",
  email: "",
  phone: "",
  gender: "",
  profilePicFile: null,
  followers: "",
  engagementRate: "",
  avgViews: "",
  categories: [],
  location: "",
  languages: [],
  audienceInsights: "",
  internalRating: undefined,
  agencyManaged: false,
  accountManager: "",
  tags: [],
  defaultFee: "",
  paymentMode: "",
  pan: "",
  gstAvailable: false,
  tdsApplicable: false,
  bio: "",
  birthday: "",
  notes: "",
};

export const GENDERS = [
  "Male",
  "Female",
  "Other",
  "Prefer not to say",
] as const;

export const PLATFORMS = ["Instagram", "YouTube"] as const;

export const PAYMENT_MODES = ["UPI", "Bank Transfer"] as const;

export const CATEGORY_OPTIONS = [
  "Fashion",
  "Technology",
  "Lifestyle",
  "Food",
  "Fitness",
  "Beauty",
  "Travel",
  "Parenting",
  "Finance",
  "Education",
  "Luxury",
  "D2C",
] as const;

export const LANGUAGE_OPTIONS = [
  "Hindi",
  "English",
  "Marathi",
  "Tamil",
  "Bengali",
  "Telugu",
  "Kannada",
  "Punjabi",
  "Gujarati",
] as const;

export const TAG_OPTIONS = [
  "fashion",
  "D2C",
  "luxury",
  "recurring",
  "no-TDS",
  "macro",
  "micro",
  "verified",
] as const;

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Lakshadweep",
  "Puducherry",
  "Andaman and Nicobar Islands",
] as const;
